export default __webpack_public_path__ + "static/049-60be640adee69f2031eed13c8ad08545.jpg";